<div  
  #dragHandleRef 
  class="drag-handle-container"
>
  <div 
    class="grab-handle"
  ></div>
</div>
